import { SegmentGroup, SegmentGroupValueChangeDetails } from '@chakra-ui/react';
import { WEEKLY_SUB_CATEGORIES, WeeklySubCategory } from '@features/prediction-markets/types';
import { memo, useCallback } from 'react';

interface Props {
  selected: WeeklySubCategory;
  onSelect: (subCategory: WeeklySubCategory) => void;
}

const WeeklySubCategoryTabs = ({ selected, onSelect }: Props) => {
  const handleValueChange = useCallback(
    (e: SegmentGroupValueChangeDetails) => {
      if (e.value != null) {
        onSelect(e.value as WeeklySubCategory);
      }
    },
    [onSelect],
  );

  return (
    <SegmentGroup.Root value={selected} onValueChange={handleValueChange} size="xs">
      <SegmentGroup.Indicator bg="surface.accent" />
      {WEEKLY_SUB_CATEGORIES.map((sub) => (
        <SegmentGroup.Item key={sub.key} value={sub.key} cursor="pointer">
          <SegmentGroup.ItemText>{sub.label}</SegmentGroup.ItemText>
          <SegmentGroup.ItemHiddenInput />
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
};

export default memo(WeeklySubCategoryTabs);
